import { string, object } from 'yup';

export const validationSchema = object().shape({
  title: string().nullable().required('Title is required'),
  category: string().nullable().required('Category is required'),
});
